import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LogIn from '../views/LogIn.vue'
import Event from '../views/Event.vue'
import Credit from '../views/Credit.vue'
import Book from '../views/Book.vue'
import Charts from '../views/Charts.vue'
import AssetCharts from '../views/AssetCharts.vue'
import Schedule from '../views/Schedule.vue'
import Reminder from '../views/Reminder.vue'
import StockPortfolio from '../views/StockPortfolio.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LogIn
  },
  {
    path: '/event',
    name: 'event',
    component: Event,
    meta: { requiresAuth: true }
  },
  {
    path: '/book',
    name: 'book',
    component: Book,
    meta: { requiresAuth: true }
  },
  {
    path: '/credit',
    name: 'credit',
    component: Credit,
    meta: { requiresAuth: true }
  },
  {
    path: '/charts',
    name: 'charts',
    component: Charts,
    meta: { requiresAuth: true }
  },
  {
    path: '/assets',
    name: 'assets',
    component: AssetCharts,
    meta: { requiresAuth: true }
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: Schedule,
    meta: { requiresAuth: true }
  },
  {
    path: '/reminder',
    name: 'reminder',
    component: Reminder,
    meta: { requiresAuth: true }
  },
  {
    path: '/stocks',
    name: 'stocks',
    component: StockPortfolio,
    meta: { requiresAuth: true }
  }
  // {
  //   path: '/addavent',
  //   name: 'addavent',
  //   component: AddEvent,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: '/transferevent',
  //   name: 'transferevent',
  //   component: TransferEvent,
  //   meta: { requiresAuth: true }
  // }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router
